import { Injectable } from '@angular/core';
import { Observable, throwError, of } from 'rxjs';

import { User } from 'src/app/model/user';
import { Admin } from 'src/app/model/admin';

@Injectable({ providedIn: 'root' })
export class UserServiceLocal {
  public getUserInfo(user: User): Observable<any> {
    const res = {
      "result": 0,
      "error_code": 0,
      "firstName": "David",
      "middleName": "",
      "lastName": "Li",
      "displayName": "David Li",
      "email": "dl@ontario.ca",
      "preferredLanguage": "en",
      "pkiuser": "false",
      "isRoleAdmin": true,
      "emailAccess": false,
      "guid": "1234-324sdf-234sd023-sdfsd34"
    };
    
    return of(res);
  }

  public register(user: User): Observable<any> {
    const res = { result: 1, error_code: 15 };
    return of(res);
  }

  public updateUserInfo(user: User): Observable<any> {
    const res = { result: 1, error_code: 9 };
    return of(res);
  }

  public updateEmail(user: User): Observable<any> {
    const res = { result: 1, error_code: 1234 };
    return of(res);
  }

  public changePassword(user: User): Observable<any> {
    const res = { result: 1, error_code: 8 };
    return of(res);
  }

  public resetPassword(user: User): Observable<any> {
    const res = { result: 1, error_code: 3 };
    return of(res);
  }

  public forgotPassword(user: User): Observable<any> {
    const res = { result: 1, error_code:0 };
    return of(res);
  }

  public getUserRoles(user: User) {
    const res = {
      "result": 0,
      "error_code": 0,
      "enrolledroles": [
        "BPCS-MOHUSER",
        "CYMH_BI_USER",
        "DDSB_DMRV_PPE_USER",
        "DDSB_DMRV_USER",
        "DDSB_DMRV_Users",
        "DDSB_ECIS_DEVD_USER",
        "DDSB_ECIS_DMQA_USER",
        "EFIS_QA_USER",
        "LRC_OP_DEV_USER",
        "MTORUS_BR_LCSS_ESDI_USER",
        "V_GSLTEST",
        "WEBFOCUS_ADMIN",
        "BPS_MPR_ADMIN"
      ]
    };

    return of(res);
  }

  public validateEmailMFA(user: User): Observable<any> {
    const res = { result: 0, error_code: 0 };
    return of(res);
  }

  public sendEmailMFA(user: User): Observable<any> {
    const res = { result: 0, error_code: 0 };
    return of(res);
  }

  public checkEmail(user: User): Observable<any> {
    const res = { result: 0, error_code: 0 };
    return of(res);
  }

  public roleReqAuthz(admin: Admin): Observable<any> {
    const res = { result: 0, error_code: 0 };
    return of(res);
  }

  public getRestrictedEmailDomains(): Observable<any> {
    const res = {
      "result": 0,
      "domains": [
        "ontario.ca",
        "ontariocis.ca"
      ]
    };
    return of(res);
  }

  public getMyServices(): Observable<any> {
    const res = {
      "result": 0,
      "count": 2,
      "services": [
        {
          "serviceNameEN": "serviceNameEN-1",
          "serviceUrlEN": "https://dev4.gc.login.security.gov.on.ca/service/EN1",
          "serviceMessageEN": "This is the service message for serviceNameEN-1",
          "serviceNameFR": "serviceNameFR-1",
          "serviceUrlFR": "https://dev4.gc.login.security.gov.on.ca/service/FR1",
          "serviceMessageFR": "Toutes les applications qui ne sont pas énumérées ici"
        },
        {
          "serviceNameEN": "serviceNameEN-2",
          "serviceUrlEN": "https://dev4.gc.login.security.gov.on.ca/service/EN2",
          "serviceMessageEN": "",
          "serviceNameFR": "serviceNameFR-2",
          "serviceUrlFR": "https://dev4.gc.login.security.gov.on.ca/service/FR2",
          "serviceMessageFR": ""
        },
        {
          "serviceNameEN": "serviceNameEN-3",
          "serviceUrlEN": "https://dev4.gc.login.security.gov.on.ca/service/EN3",
          "serviceMessageEN": "This is the service message for serviceNameEN-3",
          "serviceNameFR": "serviceNameFR-3",
          "serviceUrlFR": "https://dev4.gc.login.security.gov.on.ca/service/FR3",
          "serviceMessageFR": "Toutes les applications qui ne sont pas énumérées ici"
        }        
      ]
    }
    return of(res);
  }



  public setNewPassword(user: User): Observable<any> {
    const res = { result: 1, error_code: 0 };
    return of(res);
  }

}
